(() => {
  const label = document.body.dataset.rxReviewsLabel;
  if (!label || document.documentElement.lang.split('-')[0] === 'it') return;

  const selector = '.jdgm-prev-badge';
  const update = (badge) => {
    const rawCount = badge.getAttribute('data-number-of-reviews');
    const count = Number(rawCount);
    const text = badge.querySelector('.jdgm-prev-badge__text');
    if (rawCount === null || !Number.isInteger(count) || count < 0 || !text) return;
    const localized = `${label} (${count})`;
    // Judge.me may render again after load. Avoid generating a mutation loop.
    if (text.textContent !== localized) text.textContent = localized;
  };
  const collect = (node, badges) => {
    const element = node.nodeType === 1 ? node : node.parentElement;
    if (!element) return;
    const badge = element.closest(selector);
    if (badge) badges.add(badge);
    element.querySelectorAll(selector).forEach((item) => badges.add(item));
  };

  document.querySelectorAll(selector).forEach(update);
  const observer = new MutationObserver((records) => {
    const badges = new Set();
    records.forEach((record) => {
      // Only inspect changed badges and newly inserted subtrees, not the page.
      const owner = record.target.nodeType === 1 ? record.target : record.target.parentElement;
      const badge = owner?.closest(selector);
      if (badge) badges.add(badge);
      record.addedNodes.forEach((node) => collect(node, badges));
    });
    badges.forEach(update);
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['data-number-of-reviews']
  });
})();
